import React, { useState, useEffect } from 'react'
import Heading from 'components/shared/Heading'
import GoogleMaps from './GoogleMaps'
import { Input, Row, Col } from 'antd'

interface Location {
  lat: number
  lon: number
}

interface MarkerPosition {
  lat: number
  lng: number
}

interface Address {
  street: string
  postalArea: string
  postalCode: string
  location: Location | null
}

interface OnUpdateProps {
  address: Address
}

interface Props {
  tabs: JSX.Element
  initialValues: Address
  onUpdate: ({
    address: { street, postalArea, postalCode, location },
  }: OnUpdateProps) => void
}

const DEFAULT_INITIAL_CENTER_COORDS = { lat: 59.911712, lng: 10.748645 }

const ManualSearch = ({ tabs, onUpdate, initialValues }: Props) => {
  const { location } = initialValues

  const [street, setStreet] = useState(initialValues.street || '')
  const [postalArea, setPostalArea] = useState(initialValues.postalArea || '')
  const [postalCode, setPostalCode] = useState(initialValues.postalCode || '')
  const [markerPosition, setMarkerPosition] = useState(
    location ? { lat: location.lat, lng: location.lon } : null
  )

  useEffect(() => {
    onUpdate({
      address: {
        street,
        postalArea,
        postalCode,
        location: markerPosition
          ? { lat: markerPosition.lat, lon: markerPosition.lng }
          : null,
      },
    })
  }, [onUpdate, street, postalArea, postalCode, markerPosition])

  return (
    <div className="manual-search">
      <Heading level={3}>
        Skriv inn adressedetaljer og velg posisjon på kartet
      </Heading>

      <Row gutter={[16, 0]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 10 }}
          lg={{ span: 8 }}
        >
          <div className="inputs">
            <Input.Group size="large">
              <label>Gateadresse</label>
              <Input
                size="large"
                name="street"
                onChange={(e) => {
                  setStreet(e.target.value)
                }}
                value={street}
                placeholder="Gateadresse"
              />

              <label>Postkode</label>
              <Input
                size="large"
                name="postalCode"
                onChange={(e) => {
                  setPostalCode(e.target.value)
                }}
                value={postalCode}
                placeholder="Postkode"
              />

              <label>Poststed</label>
              <Input
                size="large"
                name="postalArea"
                onChange={(e) => {
                  setPostalArea(e.target.value)
                }}
                value={postalArea}
                placeholder="Poststed"
              />
            </Input.Group>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 14 }}
          lg={{ span: 16 }}
        >
          <GoogleMaps
            onSetMarker={(pos: MarkerPosition) => {
              setMarkerPosition(pos)
            }}
            initialCenter={
              location
                ? {
                    lat: location.lat,
                    lng: location.lon,
                  }
                : DEFAULT_INITIAL_CENTER_COORDS
            }
            zoom={markerPosition ? 18 : 8}
            markerPosition={markerPosition}
          />
        </Col>
      </Row>
      <div className="tabs">{tabs}</div>
    </div>
  )
}

export default ManualSearch
